<template>
  <client-only>
    <div>
      <SectionCompaniesInnerPages :article-length="articleLength" :limit-side-banners="limitSideBanners" />
    </div>
  </client-only>
</template>

<script>
import { includes } from 'lodash'
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages'

export default {
  components: {
    SectionCompaniesInnerPages,
  },
  props: {
    articleLength: {
      type: Number,
      required: false,
      default: 0,
    },
    limitSideBanners: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    isSingleArticlePage() {
      return includes(this.$route.path, 'article')
    },
  },
}
</script>

<style scoped>
.aside-ad {
  background: #3e4a54;
  text-align: center;
}
</style>